import React from "react"
import PropTypes from "prop-types"
import parse from "html-react-parser"
import { Container, Row, Col } from "@ui/wrapper"
import Text from "@ui/text"
import { AboutWrapper, LeftBox, RightBox } from "./about-area.style"
import { aboutArea } from "../../../dataMantiz/pages/company/aboutUs/aboutArea"

const AboutDesc = ({ descStyle }) => {
  return (
    <AboutWrapper>
      <Container>
        <Row>
          <Col lg={{ span: 4, offset: 1 }}>
            <LeftBox>
              <img src={aboutArea.img} alt="logo" />
            </LeftBox>
          </Col>
          <Col lg={{ span: 5, offset: 1 }}>
            <RightBox>
              <Text style={{ textAlign: "justify" }} {...descStyle}>
                {parse(aboutArea.description)}
              </Text>
            </RightBox>
          </Col>
        </Row>
      </Container>
    </AboutWrapper>
  )
}

AboutDesc.propTypes = {
  sectionStyle: PropTypes.object,
  descStyle: PropTypes.object,
}

AboutDesc.defaultProps = {
  descStyle: {
    fontSize: "18px",
    lineHeight: 1.67,
    mb: "23px",
  },
}

export default AboutDesc
